import { Component, HostListener, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Category, Product } from '../../models/models-vm';
import { MasterService } from '../../services/master.service';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { ErrorLoggerService } from '../../../shared/services/error-logger.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from '../../../project-intake/services/message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RoleKey } from '../../../Common/Constants/common.constants';
import { Router } from '@angular/router';
import { RolesKeysConstants } from '../../../Common/Constants/data';
import { MasterStoresComponent } from '../master-stores/master-stores.component';

@Component({
  selector: 'app-master-data-management',
  templateUrl: './master-data-management.component.html',
  styleUrls: ['./master-data-management.component.css',
    './../../../../assets/css/master_management.css']
})
export class MasterDataManagementComponent {
  @ViewChild('masterStores') masterStoresComponent?: MasterStoresComponent;

  activeTab: string = 'productstab';
  anyValueChanged: boolean = false;
  hideAll: boolean = false;

  disableExportStoresListAction: boolean = false;

  // categoriesList: Category[] = []; 
  // productsList: Product[] = [];

  // productForm!: FormGroup;
  // currentProductID?: number | null;
  // buttonText: string = "Save";

  constructor(private fb: FormBuilder,
    private masterService: MasterService,
    private msgService: MessageService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private router: Router,
    private ngxService: NgxUiLoaderService) { }

  async ngOnInit() {
    this.disableExportStoresListAction = false;

    let ctRole = (await this.userRoleService.getUserRoles())
      .some(role => role.roleKey.includes(RolesKeysConstants.RoleKey_ITAdmin));

    if (!ctRole) {
      this.router.navigate(['/unauthorized']);
      return;
    }
  }

  setActiveTab(tabName: string) {
    this.activeTab = tabName;
  }

  updateValueChangedFlag(e: boolean) {
    this.anyValueChanged = false;
  }

  onFieldValueChange(e: string) {
    this.anyValueChanged = true;
  }
  canDeActivateConfirm(): boolean {
    return this.anyValueChanged;
  }

  // @HostListener allows us to guard against browser refresh, close, etc.
  @HostListener('window:beforeunload', ['$event'])
  canDeactivate(): Observable<boolean> | boolean {
    //Change tracker related logic
    if (this.anyValueChanged) {
      return false;
    } else {
      return true;
    }
  }

  exportStoresList(): void {
    if (this.masterStoresComponent) {
      this.disableExportStoresListAction = true;
      this.masterStoresComponent.exportStoresList();
    } else {
      this.disableExportStoresListAction = false;
      console.warn('MasterStoresComponent not available');
    }
  }

  // Method to be triggered by child when export is complete
  onExportStoresListComplete(): void {
    this.disableExportStoresListAction = false; // Re-enable button, hide loader
  }
}
